var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.489,
    height: 22.948,
    viewBox: "0 0 22.489 22.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19085",
    "data-name": "Path 19085",
    d: "M141.565,109.107a9.834,9.834,0,0,0-.242-2.346H130.55v4.258h6.323a5.607,5.607,0,0,1-2.346,3.723l-.021.143,3.406,2.639.236.024a11.219,11.219,0,0,0,3.417-8.44",
    transform: "translate(-119.076 -97.378)",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19086",
    "data-name": "Path 19086",
    d: "M24.175,165.575a10.936,10.936,0,0,0,7.6-2.779l-3.621-2.8a6.791,6.791,0,0,1-3.978,1.147,6.907,6.907,0,0,1-6.528-4.768l-.135.011-3.542,2.741-.046.129a11.466,11.466,0,0,0,10.25,6.324",
    transform: "translate(-12.701 -142.627)",
    fill: "#34a853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19087",
    "data-name": "Path 19087",
    d: "M4.947,78.788a7.064,7.064,0,0,1-.382-2.269,7.423,7.423,0,0,1,.37-2.269L4.927,74.1,1.341,71.312l-.117.056a11.45,11.45,0,0,0,0,10.3l3.723-2.881",
    transform: "translate(0 -65.044)",
    fill: "#fbbc05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19088",
    "data-name": "Path 19088",
    d: "M24.175,4.437a6.359,6.359,0,0,1,4.437,1.708L31.85,2.983A11.024,11.024,0,0,0,24.175,0a11.466,11.466,0,0,0-10.25,6.323L17.635,9.2a6.936,6.936,0,0,1,6.54-4.768",
    transform: "translate(-12.701)",
    fill: "#eb4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.870659608e932fad57d01b42b0fe48c9.svg";
export { ForwardRef as ReactComponent };